<script>
const iconScales = {
  "x-small": 0.5,
  small: 0.75,
  regular: 0.9,
  large: 1,
  "x-large": 1.1
};

export default {
  props: {
    color: {
      //purple, pink or green
      type: String,
      default: "purple"
    },
    size: {
      //x-small, small, regular, large or x-large
      type: String,
      default: "regular"
    },
    appendIcon: {
      //image icon located in "/static/icons/"
      type: [Boolean, String],
      default: false
    },
    prependIcon: {
      //image icon located "/static/icons/"
      type: [Boolean, String],
      default: false
    },
    href: {
      type: [Boolean, String],
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    fullRound: {
      type: Boolean,
      default: false
    },
    depressed: {
      type: Boolean,
      default: false
    },
    to: {
      //route object or name
      type: [String, Object],
      default: ""
    },
    type: {
      type: String,
      default: "button"
    }
  },

  computed: {
    iconScale() {
      return iconScales[this.size];
    }
  }
};
</script>

<template>
  <button
    :color="color"
    :size="size"
    :outlined="outlined"
    :disabled="disabled || loading"
    :loading="loading"
    :full-round="fullRound"
    :depressed="depressed"
    :type="type"
    @click="$emit('click')"
  >
    <img v-if="prependIcon" :src="`/static/icons/${prependIcon}`" alt="ícone" />
    <slot class="content"></slot>
    <v-icon v-if="loading" class="icon" name="circle-notch" :scale="iconScale" spin />
    <img v-if="appendIcon" :src="`/static/icons/${appendIcon}`" alt="ícone" />
  </button>
</template>

<style lang="scss" scoped>
.icon {
  opacity: 0.9;
  margin-left: 5px;
}

button {
  font-family: "Roboto", sans-serif;
  border-radius: 30px;
  background-position: center;
  color: white;
  border-radius: 28px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  text-transform: uppercase;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  transition: background 0.8s;
  user-select: none;
  border: none;
  outline: none;
  margin: 5px;

  &:active {
    transition: background 0s;
  }

  @each $key, $color in $colors {
    &[color="#{$key}"] {
      background-color: $color;
    }
    &[color="#{$key}"]:hover {
      background: lighten($color, 5%)
        radial-gradient(circle, transparent 1%, lighten($color, 5%) 1%)
        center/15000%;
    }
    &[color="#{$key}"]:active {
      background-color: lighten($color, 10%);
      background-size: 100%;
    }
  }

  &[outlined] {
    @each $key, $color in $colors {
      &[color="#{$key}"] {
        background: none;
        border: 1px solid $color;
        color: $color;
        box-shadow: none;
      }
      &[color="#{$key}"]:hover {
        background: rgba($color, 0.1)
          radial-gradient(circle, transparent 1%, rgba($color, 0.1) 1%)
          center/15000%;
      }
      &[color="#{$key}"]:active {
        background-color: rgba($color, 0.05);
        background-size: 100%;
      }
    }
  }

  &[size="x-small"] {
    font-size: 10px;
    height: 20px;
    padding: 0 10px;
  }
  &[size="small"] {
    font-size: 12px;
    height: 28px;
    padding: 0 12px;
  }
  &[size="regular"] {
    font-size: 13px;
    height: 36px;
    padding: 0 16px;
  }
  &[size="large"] {
    font-size: 14px;
    height: 48px;
    padding: 0 20px;

    @media (min-width: 768px) {
      font-size: 15px;
    }
  }
  &[size="x-large"] {
    font-size: 16px;
    height: 52px;
    padding: 0 23px;

    @media (min-width: 768px) {
      font-size: 17px;
    }
  }
  &[depressed] {
    box-shadow: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_base/Button.vue